import Image from "next/image";
import type React from "react";

interface BeeConfig {
    top: string;
    left: string;
    width: number;
    height?: number;
}

interface FlyingBeesProps {
    bees: BeeConfig[];
}

const FlyingBees: React.FC<FlyingBeesProps> = ({ bees }) => (
    <div className="pointer-events-none opacity-70">
        {bees.map((bee) => (
            <div
                key={`${bee.top}-${bee.left}`}
                className="absolute"
                style={{ top: bee.top, left: bee.left, zIndex: 0 }}
            >
                <Image src="/flyingbee.png" alt="Bee" width={bee.width} height={bee.height || bee.width} />
            </div>
        ))}
    </div>
);

export default FlyingBees;
